// Note: For this to work in its current implementation, the contextBoxEl MUST be a sibling to the triggerEl as it will try and place the contextBoxEl 
// next to the triggerEl as a sibling so it doesn't sit at body level forever
export class ContextBox {
    private static closeEventListener: EventListener;
    
    public static open(contextBoxEl: Element, triggerEl: Element) {
        // If the context box is already open, then there's no reason to try and open it.
        if (!contextBoxEl || !contextBoxEl.classList.contains('hidden')) {
            return;
        }

        const triggerElPosition: DOMRect = triggerEl.getBoundingClientRect();
        const top: number = triggerElPosition.top + triggerEl.clientHeight;
        const left: number = triggerElPosition.left - (triggerEl.clientHeight * 4);

        contextBoxEl.classList.remove('hidden');
        document.body.appendChild(contextBoxEl);

        const windowHeight = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;

        // If the context box would be cut off at the bottom of the screen, show it above instead.
        if (top + contextBoxEl.clientHeight > windowHeight) {
            contextBoxEl.setAttribute('style', `top: ${top - triggerEl.clientHeight - contextBoxEl.clientHeight}px; left: ${left}px`);
            // show arrow below box
        } else {
            contextBoxEl.setAttribute('style', `top: ${top}px; left: ${left}px`);
            // show arrow above box
        }

        this.closeEventListener = (e: Event) => {
            if (e.target == contextBoxEl || contextBoxEl.contains(e.target as Node)) {
                return;
            }

            this.close(contextBoxEl, triggerEl);
        }
            
        document.addEventListener('click', this.closeEventListener);
        triggerEl.addEventListener('click', this.closeEventListener);
    }

    public static close(contextBoxEl: Element, triggerEl: Element) {
        contextBoxEl.classList.add('hidden');
        triggerEl.parentElement.insertBefore(contextBoxEl, triggerEl.nextSibling);

        // Remove the event from the close elements so as to not bloat them with events not needed.
        document.removeEventListener('click', this.closeEventListener);
        triggerEl.removeEventListener('click', this.closeEventListener);
    }
}